import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import PropTypes from "prop-types";

const CustomDialog = styled(Dialog)(({ width }) => ({
  "& .MuiDialogActions-root": {
    paddingBottom: "3.2rem"
  },
  "& .MuiDialog-paper": {
    maxWidth: "100%",
    width
  }
}));

function CustomDialogTitle(props) {
  const { children, onClose, width, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, minWidth: width }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#000"
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

CustomDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
};

function DialogModal({
  isModalOpen,
  setIsModalOpen,
  heading = "Modal Heading",
  buttonDetails,
  width = "465px",
  children
}) {
  const disableBtn = buttonDetails?.disableBtn;
  const loading = buttonDetails?.loading || false;
  const btnTitle = buttonDetails?.btnTitle || "Add";
  return (
    <CustomDialog onClose={() => setIsModalOpen(false)} open={isModalOpen} width={width}>
      <CustomDialogTitle id="customized-dialog-title" onClose={() => setIsModalOpen(false)}>
        <Typography fontWeight={600}>{heading}</Typography>
      </CustomDialogTitle>
      <DialogContent
        sx={{
          borderTop: "1px solid rgba(0, 0, 0, 0.12)",
          bgcolor: "#F6F6F6"
        }}
      >
        {children}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", bgcolor: "#F6F6F6" }}>
        <LoadingButton
          disabled={disableBtn}
          variant="contained"
          loading={loading}
          onClick={buttonDetails?.handleBtnClick}
          sx={{
            p: "4px 2.5rem",
            boxShadow: "none",
            fontWeight: "600",
            "&.MuiButton-root": {
              textTransform: "uppercase",
              fontSize: "2rem"
            }
          }}
        >
          {btnTitle}
        </LoadingButton>
      </DialogActions>
    </CustomDialog>
  );
}

export default DialogModal;

DialogModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  heading: PropTypes.string.isRequired,
  buttonDetails: PropTypes.shape({
    disableBtn: PropTypes.bool,
    loading: PropTypes.bool,
    handleBtnClick: PropTypes.func.isRequired,
    btnTitle: PropTypes.string.isRequired
  }),
  width: PropTypes.string
};
